/**
 * User Types and Interfaces
 * Provana Work Allocation System
 */

export enum UserRole {
  DIRECTOR = 'Director',                    // C-level, sees all departments
  OPERATIONS_MANAGER = 'Operations Manager', // OM, sees multiple teams
  MANAGER = 'Manager',                       // Manager, approves allocations
  SUPERVISOR = 'Supervisor',                 // Team Supervisor, sees single team
  EMPLOYEE = 'Employee',                     // Sees personal assignments
  ADMIN = 'Admin',
  OPEX = 'OPEX',                             // Reports-only access (IsAllocator=3 in PWM)
}

export interface User {
  id: string;
  email: string;
  name: string;
  role: UserRole;
  employeeId?: string;
  department?: string;
  team?: string;                            // Team ID for team-based views
  managedTeams?: string[];                  // For OM - list of team IDs they manage
  profilePhoto?: string;
  isActive: boolean;
}

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

export interface LoginResponse {
  user: User;
  token: string;
  refreshToken: string;
  expiresIn: number;
}
